"use client";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useJobFilterStore } from "../../store/useJobFilterStore";
import { useEffect } from "react";

export type Project = {
  projectTitle: string;
  startDate: string;
  endDate: string;
  current: boolean;
  projectDescription: string;
};

type ProjectField = keyof Project;

type Props = {
  onClose: () => void;
  setProject: (data: Project[]) => void;
  defaultData: Project[];
};

export default function EditProjectForm({
  onClose,
  setProject,
  defaultData,
}: Props) {

  const [projects, setProjects] = useState<Project[]>(defaultData);
  const location = useLocation();
  const lang = location.pathname.startsWith("/id") ? "id" : "en";

  const handleChange = (i: number, name: ProjectField, value: any) => {
    setProjects((prev) => {
      const updated = [...prev];
      updated[i] = { ...updated[i], [name]: value };

      if (name === "current" && value === true) {
        updated[i].endDate = "";
      }

      return updated;
    });
  };

  const addProject = () => {
    setProjects((prev) => [
      ...prev,
      {
        projectTitle: "",
        projectDescription: "",
        startDate: "",
        endDate: "",
        current: false,
      },
    ]);
  };

  const removeProject = (index: number) => {
    setProjects((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    setProject(projects);
    onClose();
  };

  return (
    <div className="space-y-10 pb-4">
      {projects.map((cert, index) => (
        <div key={index} className="border rounded-xl p-6 space-y-6 relative">
          {projects.length > 1 && (
            <button
              onClick={() => removeProject(index)}
              className="absolute top-4 right-4 text-red-500 text-sm font-semibold"
            >
              ✕ {lang === "id" ? "Hapus" : "Remove"}
            </button>
          )}

          <h3 className="text-lg font-semibold">{lang === "id" ? "Proyek" : "Project"} {index + 1}</h3>

          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium">{lang === "id" ? "Judul Proyek" : "Project Title"}</label>
              <input
                className="w-full border rounded-lg p-3"
                value={cert.projectTitle}
                onChange={(e) => handleChange(index, "projectTitle", e.target.value)}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-medium">{lang === "id" ? "Tanggal Mulai" : "Start Date"}</label>
                <input
                  type="month"
                  className="w-full border rounded-lg p-3"
                  value={cert.startDate}
                  onChange={(e) => handleChange(index, "startDate", e.target.value)}
                />
              </div>

              <div>
                <label className="text-sm font-medium">{lang === "id" ? "Tanggal Berakhir" : "End Date"}</label>
                <input
                  type="month"
                  className="w-full border rounded-lg p-3"
                  value={cert.endDate}
                  onChange={(e) => handleChange(index, "endDate", e.target.value)}
                />
              </div>
            </div>
            

            <label className="flex gap-2 items-center">
              <input
                type="checkbox"
                checked={cert.current}
                onChange={(e) => handleChange(index, "current", e.target.checked)}
              />
              {lang === "id" ? "Sampai Sekarang" : "Until Now"}
            </label>
            
            <div>
              <label className="text-sm font-medium">{lang === "id" ? "Deskripsi Proyek" : "Project Description"}</label>
              <textarea
                className="w-full border rounded-lg p-3"
                value={cert.projectDescription}
                onChange={(e) => handleChange(index, "projectDescription", e.target.value)}
              />
            </div>
          </div>
        </div>
      ))}

      <div className="flex justify-center">
        <button
          onClick={addProject}
          className="flex items-center gap-2 text-primary font-semibold"
        >
          ➕ {lang === "id" ? "Tambah Proyek" : "Add Project"}
        </button>
      </div>

      <div className="flex justify-center gap-4 pt-4 pb-2">
        <button
          onClick={onClose}
          className="px-6 py-3 rounded-lg border text-gray-500 font-semibold"
        >
          {lang === "id" ? "Batal" : "Cancel"}
        </button>
        <button
          onClick={handleSave}
          className="px-6 py-3 rounded-lg bg-primary text-white font-semibold"
        >
          {lang === "id" ? "Simpan" : "Save"}
        </button>
      </div>
    </div>
  );
}
